import { ReactElement } from 'react';
import {
  ButtonContainer,
  Circle, UnitImageHeader, InfoCardContainer, List,
  ListContainer,
  TotalContainer,
  StateImageHeader,
  TitleHeader,
  SubTitleHeader,
} from './styles';
import { Building3Icon, XCloseIcon } from '~/icons';
import { Button } from '~/components';
import { colors } from '~/styles/colors';
import { generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface InfoCardProps {
  name: string;
  scope: 'unit' | 'state';
  onClose: () => void;
  unitInfo?: { id: number, city: string };
  list: {
    label: string,
    items: {label: string, color: string}[]
  };
  total: { label: string, value: number };
}

export function InfoCard({
  name,
  onClose,
  scope,
  unitInfo,
  list,
  total,
}: Readonly<InfoCardProps>): ReactElement {
  const { t } = useTranslation();

  const Header = scope === 'state' ? StateImageHeader : UnitImageHeader;

  function onClickUnitDetails(): void {
    if (unitInfo) {
      const path = generatePath('/analise/unidades/:unitId', { unitId: unitInfo.id });
      window.open(path, '_blank');
    }
  }

  return (
    <InfoCardContainer>
      <Header>
        <div>
          <TitleHeader scope={scope}>{name}</TitleHeader>
          {unitInfo && (<SubTitleHeader>{unitInfo.city}</SubTitleHeader>)}
        </div>
        <button
          type="button"
          onClick={onClose}
          style={{ cursor: 'pointer' }}
        >
          <XCloseIcon />
        </button>
      </Header>
      <TotalContainer>
        <h5>{total.label}</h5>
        <h5 style={{ fontSize: 20 }}>{total.value}</h5>
      </TotalContainer>
      <ListContainer>
        <h5>{list.label}</h5>
        <List>
          {list.items.map((item) => (
            <li key={`key-${item.label}`}>
              <Circle color={item.color} style={{ flexShrink: 0 }} />
              <span>{item.label}</span>
            </li>
          ))}
        </List>
      </ListContainer>
      {unitInfo !== undefined && (
        <Button
          onClick={onClickUnitDetails}
          variant="primary-stroke"
          style={{ height: 33 }}
        >
          <ButtonContainer>
            <Building3Icon size="14" color={colors.icon['primary-base']} />
            <span>{t('acessarUnidade')}</span>
          </ButtonContainer>
        </Button>
      )}
    </InfoCardContainer>
  );
}
